<div *ngIf="document != null" class="container-fluid">
  <div mat-dialog-title>
    <div i18n *ngIf="document.dealerDocument_ID">Edit Document</div>
    <div i18n *ngIf="!document.dealerDocument_ID">Add Document</div>
  </div>
  <div mat-dialog-content>
    <p i18n *ngIf="!document.dealerDocument_ID">To add a new document, complete the form below then click Submit.</p>
    <p i18n *ngIf="document.dealerDocument_ID">Make the necessary changes on the form below then click Submit.</p>
    <form #documentForm="ngForm" (ngSubmit)="saveDocument(documentForm)">
      <div class="form-group row">
        <label for="quoteNote_Text" class="col-sm-3 col-form-label" i18n>Description</label>
        <div class="col-sm-9">
          <textarea #documentNote name="document_Description" id="document_Description"
                    [(ngModel)]="document.document_Description" #quoteNote_Text="ngModel"
                    class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="note" class="col-sm-3 col-form-label" i18n>Attachment</label>
        <div class="col-sm-9">
          <div class="custom-file">
            <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"></app-file-upload>
            {{document.document_FileName}}
          </div>
        </div>
      </div>
      <div [hidden]="!documentForm.submitted || documentForm.valid"
           class="alert alert-danger" i18n>Validation issues encountered</div>
      <div class="row">
        <div *ngIf="!isRequesting">
          <button type="submit" class="btn btn-bidit-submit mr-1" cdkFocusInitial i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </form>
  </div>
</div>
